/**
 * Zeitgrenzen für die Datumsfilter der Protokollseite.
 *
 * `protokoll.timestamp` liegt als Zahl (Millisekunden) vor — so schreibt ihn
 * der Fahrzeug-Dialog, und so verlangt ihn das Regelwerk. Ein Filter mit
 * `Timestamp` träfe in Firestore nie eine Zahl, deshalb rechnen die Grenzen
 * ebenfalls in Millisekunden. Die Tage gelten in der Ortszeit des Browsers.
 */
export const datumsfilterGrenzen = ({fromDate, toDate}) => {
  return {
    von: fromDate ? new Date(fromDate + "T00:00:00").getTime() : null,
    bis: toDate ? new Date(toDate + "T23:59:59.999").getTime() : null,
  };
};
